import { F0TableOfContent } from '@factorialco/f0-react/dist/experimental'
import { OneOnOnesScheduledMeetingItemFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { DeleteMeetingDialog } from 'modules/meetings/components/DeleteMeetingDialog'
import { useMeetingNavigationItems } from 'modules/meetings/lib/hooks/useMeetingNavigationItems'

interface MeetingsDefaultNavigationProps {
  scheduledUpcomingMeetings: OneOnOnesScheduledMeetingItemFragment[]
  scheduledPastMeetings: OneOnOnesScheduledMeetingItemFragment[]
  employeeId: number
  refetch: () => void
}

export const MeetingsDefaultNavigation = ({
  scheduledUpcomingMeetings,
  scheduledPastMeetings,
  employeeId,
  refetch,
}: MeetingsDefaultNavigationProps) => {
  const { createMeetingItems, meetingId, openDelete, meetingToDelete, handleCloseDelete } =
    useMeetingNavigationItems({
      employeeId,
      refetch,
    })

  const upcomingItems = createMeetingItems(scheduledUpcomingMeetings)
  const pastItems = createMeetingItems(scheduledPastMeetings)

  const items = [
    ...(upcomingItems.length > 0
      ? [
          {
            id: 'upcoming',
            label: i18n.t('meetings.one_on_ones.meeting_navigation.upcoming'),
            children: upcomingItems,
          },
        ]
      : []),
    ...(pastItems.length > 0
      ? [
          {
            id: 'last',
            label: i18n.t('meetings.one_on_ones.meeting_navigation.last'),
            children: pastItems,
          },
        ]
      : []),
  ]

  return (
    <>
      <F0TableOfContent
        key={JSON.stringify([
          ...scheduledUpcomingMeetings.map((m) => m.id),
          ...scheduledPastMeetings.map((m) => m.id),
        ])}
        activeItem={meetingId}
        items={items}
        title={
          scheduledUpcomingMeetings.length > 0 || scheduledPastMeetings.length > 0
            ? i18n.t('meetings.one_on_ones.meeting_navigation.title')
            : i18n.t('meetings.one_on_ones.meeting_navigation.no_meetings')
        }
      />

      {meetingToDelete?.template?.id && (
        <DeleteMeetingDialog
          open={openDelete}
          onClose={handleCloseDelete}
          templateId={Number(meetingToDelete.template.id)}
          date={meetingToDelete?.date}
          frequency={meetingToDelete?.template?.frequency}
          meetingId={meetingToDelete?.id}
        />
      )}
    </>
  )
}
